import InboxDetailScreen from "@components/Activity/InboxDetailScreen";

export default InboxDetailScreen;
